import type React from 'react';
import { Button } from 'shared-portal-components-v2';

import type { SessionSnapshot } from '@/types/Diagnostics';

interface SessionTabProps {
  sessionSnapshot: SessionSnapshot | null;
  onCopyReduxState: () => void;
}

export default function SessionTab({
  sessionSnapshot,
  onCopyReduxState,
}: SessionTabProps): React.JSX.Element {
  if (sessionSnapshot === null) {
    return <p className="text-sm text-muted-foreground">No signed-in user.</p>;
  }

  const { userId, name, organization, email, department } = sessionSnapshot;

  return (
    <div className="flex flex-col gap-4 text-sm">
      <dl className="space-y-2">
        <div className="flex justify-between gap-4">
          <dt className="text-muted-foreground">User ID</dt>
          <dd className="break-all font-mono text-xs font-medium text-foreground">{userId}</dd>
        </div>
        <div className="flex justify-between gap-4">
          <dt className="text-muted-foreground">Name</dt>
          <dd className="font-medium text-foreground">{name}</dd>
        </div>
        <div className="flex justify-between gap-4">
          <dt className="text-muted-foreground">Organization</dt>
          <dd className="font-medium text-foreground">{organization}</dd>
        </div>
        {email !== undefined && (
          <div className="flex justify-between gap-4">
            <dt className="text-muted-foreground">Email</dt>
            <dd className="break-all font-medium text-foreground">{email}</dd>
          </div>
        )}
        {department !== undefined && (
          <div className="flex justify-between gap-4">
            <dt className="text-muted-foreground">Department</dt>
            <dd className="font-medium text-foreground">{department}</dd>
          </div>
        )}
      </dl>

      <div>
        <Button variant="primary" size="md" onClick={onCopyReduxState}>
          Copy Redux state
        </Button>
        <p className="mt-1 text-xs text-muted-foreground">
          Redacted snapshot — auth tokens, session keys, file keys, and PII are stripped.
        </p>
      </div>
    </div>
  );
}
